import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import type { ICellRendererParams } from 'ag-grid-community';
import type { MillSheetSource } from '../../types/millSheetSearch';

const DeliveryLocationCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  const data: MillSheetSource = params.data;
  const deliveryLocationCode: string = data['受渡場所コード'];
  const deliveryLocationName: string | undefined | null = params.value;
  // console.log(deliveryLocationCode, deliveryLocationName);
  const { deliveryLocations } = useSelector((state: RootState) => state.deliveryLocation);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    if (deliveryLocations !== undefined) {
      const name: string | undefined =
        deliveryLocationName && deliveryLocationName !== ''
          ? // deliveryNameがあればそれをそのまま使う
            deliveryLocationName
          : // deliveryNameがなければdeliveryLocationsから該当するものを探してその名前を使う
            deliveryLocations.find((location) => location.code === deliveryLocationCode)?.deliveryName;
      setDisplayName(name ?? deliveryLocationName);
    }
  }, [deliveryLocations]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="delivery-site-name">{displayName}</span>;
};

export default DeliveryLocationCellRenderer;
